import React, { useEffect, useState } from "react";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import Table from "../../../components/tables/Table";
import { toast } from "react-toastify";
import CustomLoading from "../../../components/customLoading/CustomLoading";
import { getNewHudPatientsOintments, getNewHudPatientsTablets, getNewHudPatientsPhotoOfDates } from "../../../services/new_clinic/new_hud_patients";

const NewPatientMedicineView = ({ patientId, openedFor }) => {
    const [loading, setLoading] = useState(false);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Medicines", key: "medicines" },
        { label: "Date", key: "created_at" },
    ];

    const Photoheaders = [
        { label: "S. No.", key: "i" },
        { label: "Date", key: "created_at" },
    ];
    const [tableData, setTableData] = useState([]);

    const fetchTabletData = async (patientId) => {
        try {
            let res = await getNewHudPatientsTablets(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchOintmentData = async (patientId) => {
        try {
            let res = await getNewHudPatientsOintments(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    const fetchPhotosData = async (patientId) => {
        try {
            let res = await getNewHudPatientsPhotoOfDates(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (openedFor === "tablet") {
            fetchTabletData(patientId);
        } else if (openedFor === "ointment") {
            fetchOintmentData(patientId);
        } else if (openedFor === "photo") {
            fetchPhotosData(patientId);
        }
    }, [patientId, openedFor]);


    return (
        loading ? <CustomLoading /> :
            <>
                <div className="w-full flex-1">
                    <StyledHeadingText text={"PATIENT " + openedFor.toUpperCase()} size={"mb-2"} />
                    {openedFor === "tablet" || openedFor === "ointment" ? <Table
                        headers={headers}
                        rows={tableData.map((item, index) => {
                            console.log('Processing item:', item);
                            return {
                                i: String(index + 1),
                                created_at: String(item.date || ''),
                                medicines: String(item.medicines || '')
                            };
                        })}
                    /> : <Table
                        headers={Photoheaders}
                        rows={tableData.map((item, index) => ({
                            i: String(index + 1),
                            created_at: String(item || '')
                        }))}
                    />}
                </div >
            </>
    );
};

export default NewPatientMedicineView;
